import { OnDestroy, Injector, Injectable } from '@angular/core';
import { LoggerParamsTransformer } from '@content-platform/web-angular-shared-util-logging';
import { Subject } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { getCurrentUserProfile } from '../selectors/ad-user.selectors';
import { UserProfile } from '../models';
import { takeUntil } from 'rxjs/operators';
@Injectable()
export class GraphApiLoggingTransformer extends LoggerParamsTransformer implements OnDestroy {
  private user: UserProfile;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(protected injector: Injector) {
    super(injector);
  }

  initialize() {
    const store = this.injector.get(Store);

    store
      .pipe(select(getCurrentUserProfile))
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => (this.user = user));
  }

  getParams() {
    return {
      userType: this.user && this.user.userType,
      uuid: this.user && this.user.objectId,
    };
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
